import React, { ReactNode } from "react";

import Box from "veneer/Box";

import DevicesMap from "cortex/ui/src/fleet/view/device/component/DevicesMap";
import {
  CurrentTimeWidget,
  QuickLinksWidget,
  SectionHeadingWidget,
  TextNoteWidget,
  WidgetContainer,
} from "cortex/ui/src/ui/dashboard";

import {
  EventsWidget,
  NetworkUptimeWidget,
  RecentIncidentsWidget,
  StrategyDistributionWidget,
} from "./DashboardWidgets";
import { DashboardWidgetLayout } from "./dashboardLayout";
import PlayerVersionTable from "./PlayerVersionTable";

export type OverviewSummaryWidgets = Record<
  "device-metrics" | "last-connected" | "total-devices" | "uptime-average",
  ReactNode
>;

export function renderOverviewDashboardWidget(
  widget: DashboardWidgetLayout,
  summaryWidgets: OverviewSummaryWidgets,
) {
  switch (widget.type) {
    case "current-time":
      return <CurrentTimeWidget />;
    case "device-locations":
      return (
        <WidgetContainer title="Device Locations">
          <Box display="flex" flex={1} minHeight={360} px={1}>
            <DevicesMap />
          </Box>
        </WidgetContainer>
      );
    case "device-metrics":
      return summaryWidgets["device-metrics"];
    case "events-24-hours":
      return <EventsWidget />;
    case "last-connected":
      return summaryWidgets["last-connected"];
    case "network-uptime":
      return <NetworkUptimeWidget />;
    case "player-versions":
      return <PlayerVersionTable />;
    case "quick-links":
      return <QuickLinksWidget config={widget.config} />;
    case "recent-incidents":
      return <RecentIncidentsWidget />;
    case "section-heading":
      return <SectionHeadingWidget config={widget.config} />;
    case "strategy-distribution":
      return <StrategyDistributionWidget />;
    case "text-note":
      return <TextNoteWidget config={widget.config} />;
    case "total-devices":
      return summaryWidgets["total-devices"];
    case "uptime-average":
      return summaryWidgets["uptime-average"];
  }
}
